// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2rcue","requiredAsterisk":"Info_requiredAsterisk__1i9ef"};